<template>
  <div class="main" ref="main">
    <el-container class="container" style="100%;">
      <el-aside :width="asideWidth+'px'" style="background-color: #FFFFFF; padding-left: 10px" ref="aside"
        v-if="showFenLei">
				<el-select v-model="AppID" placeholder="请选择应用" style="margin-right: 0px; width: 100%;" @change="selectApp">
					<el-option
						v-for="item in AppList"
						:key="item.AutoID"
						:label="item.应用名称"
						:value="item.AutoID">
					</el-option>
				</el-select>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini" :disabled="!loaded2">
        </el-input>
        <div style="overflow-y: auto;" id="tree_content">
          <el-tree :data="muluList" node-key="ID" :current-node-key="currentKey" :highlight-current="true"
            :filter-node-method="filterNode" :accordion="false"
            :expand-on-click-node="false" ref="tree" style="width: 100%;" @node-click="getNode"
            :empty-text="emptyText" :default-expanded-keys="expandedKeys">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span :id="data.key">
                <span v-if="!data.类别">
                  <span>
                    <img src="/static/images/folder-open.png" class="node-icon" v-if="node.expanded==true" />
                    <img src="/static/images/folder.png" class="node-icon" v-else />
                    {{ data.label }}
                  </span>
                </span>
                <span v-if="data.类别 === '用途'">
                  <i class="el-icon-s-order node-icon-2" style="margin-right: 0px;" alt="1"></i>
                  {{ data.名称 }}
                  <span v-if="data.启用=='1'" class="el-icon-check"></span>
                </span>

              </span>
            </span>
          </el-tree>
        </div>

      </el-aside>

      <el-main style="position: relative;">
        <i class="sacle" @click="sacle" @mousedown="mouseDown($event)" @dblclick="zoom" v-if="showFenLei"></i>
        <div>
					<div class="tools">
					  <el-button type="success" plain size="mini" icon="el-icon-plus" @click="openDialog($event,'new')" :disabled="!AppID || AppID==0 || !currentMuLuID || currentMuLuID==0">新建</el-button>
						<el-button type="primary" plain size="mini" icon="el-icon-edit" @click="openDialog($event,'edit')" :disabled="currentId==0"> 修改</el-button>
						<el-button type="primary" plain size="mini" icon="el-icon-view" @click="openDialog($event,'view')" :disabled="currentId==0"> 查看</el-button>
						<el-button type="danger" plain size="mini" icon="el-icon-delete" @click="delWenDang($event)" :disabled="currentId==0">删除</el-button>
						<el-button type="primary" plain size="mini" @click="openDialog($event, 'update')" :disabled="currentId==0"><i class="el-icon-edit-outline delete-icon"></i>变更目录</el-button>
						<el-button type="primary" plain size="mini" @click="shunxu('up')" :disabled="currentId==0 || !!keyword"><i class="el-icon-top move-icon"></i>上移</el-button>
						<el-button type="primary" plain size="mini" @click="shunxu('down')" :disabled="currentId==0 || !!keyword"><i class="el-icon-bottom move-icon"></i>下移</el-button>
						<el-button type="primary" plain size="mini" @click="refreshWenDangShunxu()" :disabled="!currentMuLuID || tableData.length==0 || !!keyword"><i class="el-icon-refresh"></i>重算顺序</el-button>
						
						<el-input placeholder="关键字，多个关键字用|隔开" size="small" v-model="keyword" @keypress.enter.native="search" class="input-with-select" style="margin-left: 10px; width: 250px;" clearable>
						    
						    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
						  </el-input>
					</div>
					<el-table
						:data="tableData"
						border
						size="mini"
						stripe
						highlight-current-row
						:fit="false"
						@row-click="rowClick"
						@row-dblclick="openDialog($event,'edit')"
						ref="tabRef"
						:height="tableHeight"
						:header-cell-style="headClass"
						fit
						>
						<el-table-column type="index" width="50px" align="center"></el-table-column>
					  <el-table-column  prop="启用" label="启用" align="center" width="50px">
					  	<template slot-scope="scope">
					  		<i class="ri-checkbox-line" v-if="scope.row.启用=='1'" style="font-size: 20px"></i>
					  		<i class="ri-checkbox-blank-line" v-else style="font-size: 20px"></i>
					  	</template>
					  </el-table-column>
					  <el-table-column  prop="标题" label="标题" align="left">
							<template slot-scope="scope">
								{{scope.row.标题}}
								<!-- <span v-if="scope.row.带视频=='1'" class="ri-live-line" style="font-size: 18px; vertical-align: bottom;"></span> -->
								<span v-if="scope.row.带视频=='1'"><img src="../assets/camera.png" height="14"></span>
							</template>
						</el-table-column>
					  <el-table-column  prop="目录名称" label="所在目录" align="left" width="200px" v-if="keyword"></el-table-column>
					  <el-table-column  prop="备注" label="备注" align="left" width="100px" show-overflow-tooltip></el-table-column>
					  <el-table-column  prop="编辑人备注" label="编辑人备注" align="left" width="100px"show-overflow-tooltip></el-table-column>
					  <el-table-column  prop="最后备注时间" label="最后备注时间" align="center" width="155px">
					  	<template slot-scope="scope">
					  		{{scope.row.最后备注时间}}
					  	</template>
					  </el-table-column>
						<el-table-column  prop="创建人" label="创建人" align="center" width="100px"></el-table-column>
						<el-table-column  prop="创建时间" label="创建时间" align="center" width="100px">
							<template slot-scope="scope">
								{{scope.row.创建时间.substring(0,scope.row.创建时间.indexOf(' '))}}
							</template>
						</el-table-column>
					</el-table>
				</div>
      </el-main>
    </el-container>
    <el-dialog id="newDialog" ref="newDialog" :title="formTitle" :visible.sync="dialogFormVisible" width="450px" :close-on-click-modal="false" v-dialogDrag>
      <div class="dialog-container">
        
    		<el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="dialogFormVisible && type=='update'">
    		
    		  <el-form-item label="所属目录" prop="MainID">
    		    <TreeSelect :props="props" :options="muluList" :value="form.MainID" :label="form.所属目录" :clearable="true" :accordion="false" @getValue="getValue"></TreeSelect>
    		  </el-form-item>
    		  <el-form-item label="标题" prop="标题">
    		    <el-input v-model="form.标题" readonly="readonly"></el-input>
    		  </el-form-item>
    		  
    		  <el-row>
    		    <el-button ref="sendButton" type="primary" @click="submitForm('form')" size="small">保存</el-button>
    		    <el-button ref="sendButton" type="warning" @click="closeDialog" size="small">关闭</el-button>
    		  </el-row>
    		</el-form>
      </div>
    	
    </el-dialog>
  </div>
</template>

<script>
  import * as util from "@/utils/util.js"
  import '@/utils/directives.js';
  import TreeSelect from "@/components/TreeSelect.vue";
  
  let _ = require('lodash')

  export default {
    data() {
      return {
				AppList: [],
				muluList: [],
        tableData: [],
        tableHeight: 'auto',
        asideWidth: 300, //侧边栏默认宽度
				asideMinWidth: 30, //侧边栏最小宽度
				asideMaxWidth: 500, //侧边栏最大宽度
        dialogVisible: false,
				showFenLei: true,
				emptyText: '正在加载模块……',
				currentNode: '',
				currentKey: '',
				filterText: '',
				loaded2: false,
				dialogName: '',
				formTitle: '',
				showModal: true,
				type: '',
				dingShiQiArr: [],
				AppID: '',
				currentRow: '',
				currentIndex: 0,
				currentId: '',
				expandAll: false,
				data: [],
				expandedKeys: ['0'],
				currentMuLuID: '',
				form: {
				  AutoID: '0',
				  MainID: '0',
				  所属目录: '',
				  标题: '',
				  AppID: '0',
				},
				dialogFormVisible: false,
				formTitle: '',
				props:{                // 配置项（必选）
				  value: 'ID',
				  label: 'label',
				  pathkey: 'PathKey',
				  children: 'children',
					keyValue: 'ID',
				  // disabled:true
				},
				rules: {
				  所属目录: [
				    { required: true, message: '请选择所属目录', trigger: 'change' }
				  ],
				  
				},
				keyword: '',
				
      }
    },
    components: {TreeSelect},
    methods: {
      // 表头样式设置
      headClass() {
        return util.tableHeadClass();
      },
      filterNode(value, data) {
        if (!value) return true;
				
				value=value.replace(/    /g,' ');
				value=value.replace(/   /g,' ');
				value=value.replace(/  /g,' ');
				value=value.trim();
				
				let tempVal=value.split(' ');
				
				let flag=false;
				for(let val of tempVal){
					flag = flag || data.名称.indexOf(val) !== -1;
				}
        
				return flag;
      },
      GetWenDangList(keyword='') {
				if(!keyword){
					keyword=this.keyword;
				}
				if(!this.currentMuLuID && !keyword){
					return;
				}
				//this.currentId='';
				
        let url = "/Handler/WenDang.ashx?mode=GetWenDangList";
        this.$ajax.post(url, {
          MainID: this.currentMuLuID,
					AppID: this.AppID,
					KeyWord: keyword,
					
        }).then((response) => {
          //console.log("response:");
          //console.log(response.data);
          let errorCode = response.data.errorCode;

          if (errorCode == '0') {
            //console.log(errorCode)
            this.tableData = response.data.data;
						
						let row = this.tableData.find(item => item.AutoID == this.currentRow.AutoID);
						this.$refs.tabRef.setCurrentRow(row);
          }

        }, function(err) {
          //console.log(err);

        });
      },
			search(){
				if(!this.keyword){
					this.$message('请输入关键字！');
					return;
				}
				this.GetWenDangList(this.keyword)
			},
      openDialog(event, type) {
        if(type==="new"){
          
          this.$router.push({path: '/webdanglist/new/' + this.AppID + '/' + this.currentMuLuID + ''});
          return;
        }else if(type==="edit"){
          if(this.currentId!=0){
            
            this.$router.push({path: '/webdanglist/edit/' + this.currentRow.AutoID});
            return;
          }
          else {
            return  this.$message.warning("先选择要编辑的文档")
          }
        			
        }else if(type==="view"){
          if(this.currentId!=0){
            
            this.$router.push({path: '/webdanglist/view/' + this.currentRow.AutoID});
            return;
          }
          else {
            return  this.$message.warning("先选择要查看的文档")
          }
        }
				else if (type == 'update') {
				  this.type = 'update';
				  this.formTitle = '变更父目录';
				  this.dialogFormVisible = true;
				  
				  if (this.currentId == 0) {
				    this.$message({
				      type: 'error',
				      message: '请先选择要变更的文档'
				    });
				    this.dialogFormVisible = false;
				  }
				  else
				  {
				    //console.log(event);
				    //this.requestMuLuData();
						
						this.form=this.currentRow;
						this.form.所属目录=this.currentNode.目录名称;
						
						//console.log(this.currentNode);
						
						let weizhi=util.WeiZhi(event,450, 450,0,0,1);
						//console.log(weizhi);
						
						let l=weizhi.left;
						let t=weizhi.top;
						
						//const el = this.$refs['newDialog'];
						let el=document.querySelector('#newDialog');
						const dragDom = el.querySelector('.el-dialog');
						
						//console.log(dragDom,l,t)
						dragDom.style.marginTop = '0px';
						dragDom.style.left = l + 'px';
						dragDom.style.top = t + 'px';
				  }
				}
      },
      closeDialog() {

        this.dialogVisible = false;
        this.previewJson = '';
      },
      mouseDown(e) {
        let that = this;
        let oldX = e.pageX;
        let oldWidth = this.asideWidth;

        document.onmousemove = _.debounce((e) => { //利用lodashJS防抖动，间隔50毫秒计算一次窗口高度、宽度
          let newX = e.pageX - oldX;
          let newWidth = newX + oldWidth;

          //that.asideWidth = (newX + that.asideWidth)>=480?480:(newX + that.asideWidth);

          if (newWidth < this.asideMinWidth) {
            newWidth = this.asideMinWidth;
          } else if (newWidth > this.asideMaxWidth) {
            newWidth = this.asideMaxWidth;
          }

          that.asideWidth = newWidth;

          //console.log(oldX,e.pageX,newX,that.asideWidth);
        }, 1);
        document.onmouseup = function() {
          document.onmousemove = document.onmouseup = null;
        }
        e.stopPropagation();
      },
      sacle(e) {
        e.stopPropagation();
      },
      zoom() {
        if (this.asideWidth > this.asideMinWidth) {
          this.asideWidth = this.asideMinWidth;
        } else {
          this.asideWidth = this.asideMaxWidth;
        }

      },
      shunxu: _.debounce(async function(type) { //利用lodashJS防抖动，间隔30毫秒移动一次顺序
        //console.log(type,this.asideWidth);
        if (this.currentId == 0) {
          this.$message({
            type: 'error',
            message: '请先选择要调整的文档'
          });
          return;
        }
        
        let url="/Handler/WenDang.ashx?mode=" + type;
        this.$ajax.post(url,{AutoID: this.currentId, MainID: this.currentMuLuID}).then((response)=>{
          //console.log(response.data);
          let value=response.data;
        
          let errorCode=value.errorCode;
        
          if(errorCode=="0")
          {
        
            this.GetWenDangList();
        
          }
          else
          {
            let desc=value.desc;
            this.$message({
              type: 'error',
              message: desc
            });
          }
				},function(err){
          //console.log(err);
        });
        
        //console.log(this.currentIndex);
      }, 30),
      calcTableHeight(){
				let h=210;
				let h1 = this.clientHeight - h;
				
				this.tableHeight = h1;
				
			},
			getNode(node) {
				//console.log('node:', node.名称, node.ID);
				this.currentNode=node;
				
				this.currentMuLuID=node.ID;
				
				sessionStorage.setItem('currentMuLuID', this.currentMuLuID);
				
				this.GetWenDangList();
				
				this.$nextTick(() => {
					let dom = document.querySelector(
						'#buju .el-table__header-wrapper .el-table__header .has-gutter .el-checkbox');
					//console.log(dom);
					if (dom) {
						dom.style.display = 'none';
					}
					
				})
				//console.log(this.表格名称, this.用途)
			},
			GetMuLuList(){
				if(!this.AppID || this.AppID=='0'){
					Alert('请选择应用名称！');
					return;
				}
			  let url="/Handler/MuLu.ashx?mode=GetMuLuList";
			  this.$ajax.post(url,{AppID: this.AppID}).then((response)=>{
			    //console.log(response.data);
			    //console.log(JSON.stringify(response.data));
			    let errorCode=response.data.errorCode;
			    if(errorCode=='0')
			    {
			      this.currentNode = response.data.data.find(item=>item.ID==this.currentMuLuID);
			
			      this.data = [{label: '根目录', ID: '0', AutoID: '0',disabled: true, children: util.translateDataToTree(response.data.data,'目录名称','目录名称')}];
			
			      this.muluList=JSON.parse(JSON.stringify(this.data));
						this.loaded2=true;
			      this.$nextTick(function(){
			        if(this.currentNode!=undefined&&this.currentNode!='')
			        {
			          this.$refs.tree.setCurrentNode(this.currentNode);
			        }
			        this.loaded=true;
			        let t=this.filterText;
			        this.filterText='';
			        let t2 = setTimeout(()=>{
			          this.filterText=t;
			        },10);
							
							this.dingShiQiArr.push(t2);
							
			        this.expandAllNodes(this.expandAll);  //根据当前设置（expandAll）展开/收起Tree
			
			        
			        if(this.currentNode){
			          this.expandedKeys=[this.currentNode.ID];  //展开当前节点
			        }
			      })
			    }
			    //console.log(response.data);        },function(err){
			    //console.log(err);
			  });
			},
			expandAllNodes(state,data=''){
			  //console.log('state:',state);
			  this.expandAll=state;
			  if(data==''){
			    data=this.data;
			  }
			  this.expandAll=state;
			  data.forEach((item, index)=>{
			    //console.log(item);
			    if(item.ID!=0){
			      this.$refs.tree.store.nodesMap[item.ID].expanded=state;
			    }
			
			    if(item.children && item.children.length>0){
			      this.expandAllNodes(state,item.children);
			    }
			  })
			},
			async getAppList(){
			  let url="/Handler/App.ashx?mode=GetAPPList";
				
				let payload={};
				
				const {data: resData} = await this.$ajax.post(url,payload);
				
				let errorCode=resData.errorCode;
				
				if(errorCode=='0'){
					this.AppList=resData.data;
					
					if(this.AppList.length>0 && (!this.AppID || this.AppID=='0')){
						this.AppID=this.AppList[0].AutoID;
						
						sessionStorage.setItem('WenDangAppID', this.AppID);
					}
					
					this.GetMuLuList();
					
				}
				else{
					let desc=resData.desc;
					
					this.$message({
					  type: 'error',
					  message: '获取失败，' + desc
					});
				}
			  
			},
			//单击选中列
			rowClick(row, column, event){
			  if(row!==null){
			    //console.log(row);
			    this.currentId=row.AutoID;
			    this.currentRow=row;
					
			  }
			},
			selectApp(val){
				//console.log('selectApp', val);
				
				sessionStorage.setItem('WenDangAppID', this.AppID);
				
				this.tableData=[];
				this.currentMuLuID='';
				this.currentId='';
				
				this.GetMuLuList();
			},
			delWenDang(event){
				if(this.currentId==0){
					this.$message({
					  type: 'error',
					  message: '请选择要删除的文档'
					});
					return;
				}
				this.$confirm('确定要删除吗?', '提示', {
				  cancelButtonClass: 'btn-custom-cancel',
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  center: false,
				}).then(() => {
				
				  var url="/Handler/WenDang.ashx?mode=delWenDang";
				  this.$ajax.post(url,{AutoID: this.currentId}).then((response)=>{
				    //console.log(response.data);
				    //let jsonData=JSON.parse(response.bodyText);
				    //console.log(jsonData[0]);
						if(response.data.errorCode=='0'){
							this.currentId=0;
							
							this.GetWenDangList();
						}
				    else{
							
							this.$message({
							  type: 'error',
							  message: '删除失败'
							});
						}
				
				  },function(err){
				    console.log(err);
				  });
				});
				
			},
			getValue(title,value,pathkey){
				//console.log('getValue',title,value,pathkey);
				
			  this.form.MainID = value;
			  
			  console.log(this.form);
			},
			submitForm(formName) {
				if(!this.AppID || this.AppID=='0'){
					util.Alert('请先选择应用！');
					return;
				}
				
				
			  this.$refs[formName].validate((valid) => {
			    if (valid) {
			      //console.log(JSON.stringify(this.form));
			      //alert('submit!');
			
			      let url="/Handler/WenDang.ashx?mode=updateWenDangMulu";
			      this.$ajax.post(url,this.form).then((response)=>{
			        //console.log(response.data);
			      						
			        let value=response.data;
			      						
			        let type=value.errorCode;
			      						
			        
			        if(type=="0")
			        {
			      		this.currentId=value.AutoID;
			      		
			          this.$message({
			            type: 'success',
			            message: '变更成功'
			          });
			          this.closeDialog();
			          this.GetWenDangList();
			      		
			        }
			        else
			        {
			          let desc=value.desc;
			          // this.$message({
			          //   type: 'warning',
			          //   message: '编辑失败: ' + desc
			          // });
			      		Alert('变更失败: ' + desc);
			        }
			      						
			      },function(err){
			        //console.log(err);
			      });
			
			    } else {
			     //console.log('error submit!!');
			      return false;
			    }
			  });
			},
			closeDialog() {
			  this.dialogFormVisible = false;
			  //this.resetForm("form");
			
			},
			refreshWenDangShunxu(){
			  if (!this.currentMuLuID) {
			    this.$message({
			      type: 'error',
			      message: '请先选择要重算的目录'
			    });
			    return;
			  }
			  
			
			  let url="/Handler/WenDang.ashx?mode=refreshWenDangShunxu";
			  this.$ajax.post(url,{MainID: this.currentMuLuID}).then((response)=>{
			    //console.log(response.data);
			    //let jsonData=JSON.parse(response.bodyText);
			    //console.log(jsonData[0]);
			    //this.currentID=0;
			    let value=response.data;
			
			    let errorCode=value.errorCode;
			
			    if(errorCode=="0")
			    {
			      this.$alert('重算顺序成功', '系统提示', {
			        confirmButtonText: '确定',
			        callback: action => {
			          this.GetWenDangList();
			        }
			      });
					}
			    else
			    {
			      let desc=value.desc;
			      this.$message({
			        type: 'error',
			        message: desc
			      });
			    }        },function(err){
			    //console.log(err);
			  });
			},
			
    },
    props: [],
    mounted() {
			//console.log('list activated');
			
			this.AppID=sessionStorage.getItem('WenDangAppID');
			this.currentMuLuID=sessionStorage.getItem('currentMuLuID');
			
			this.getAppList();
			
			this.GetWenDangList();
			
			this.$nextTick(()=>{
				this.calcTableHeight();
			})
    },
    beforeDestroy(){
    	//console.log('beforeDestroy', this.dingShiQiArr.length,this);
    	
    	this.dingShiQiArr.forEach(item=>{
    		clearTimeout(item);
    	})
    },
		activated() {
			//console.log('currentId', this.currentId);
			
			this.AppID=sessionStorage.getItem('WenDangAppID');
			this.currentMuLuID=sessionStorage.getItem('currentMuLuID');
			
			this.getAppList();
			
			this.GetWenDangList();
			
			this.$nextTick(()=>{
				this.calcTableHeight();
			})
		},
		computed: {
      clientHeight() {
        return this.$store.state.screenHeight;
      },
      
    },
    watch: {
      clientHeight: function(val) { //监听屏幕高度变化

        
        this.$nextTick(() => {
          this.calcTableHeight();
        });

      },
      filterText: function(val) {
        //console.log(val);
        this.$refs.tree.filter(val);
      },
      
    },
    
  }
</script>

<style lang="scss" scoped>
  .main {
    padding-left: 0;
    position: relative;
    height: 100%;
    width: 100%;
    border: 0px solid #000;

    .container {
      padding: 0;
      position: absolute;
      top: 0px;
      bottom: 0px;
      width: 100%;
      height: 100%;
      border: 0px solid #FF6600;
    }

    .content {
      // margin: 5px;
      // padding: 5px;
      background-color: #FFFFFF;
      overflow-x: auto;
      border: 0px solid #0000EE;
    }

    .sacle {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 5px;
      background-color: #89C7F5;
      cursor: w-resize;
    }

  }
	
  /deep/ .el-select-dropdown {
    max-width: 1000px;;
  }
	
	
	/deep/ .elx-table .elx-body--column.col--ellipsis {
	  height: 34px;
	}
	
	/deep/ .elx-table .elx-footer--column.col--ellipsis {
	  height: 34px;
	}
	
	/deep/ .elx-table .elx-header--column.col--ellipsis {
	  height: 36px;
	}
	
	/deep/ .elx-table.elx-editable .elx-body--column {
	  height: 34px;
	}
	
	/deep/ .elx-table .elx-header--column.col--ellipsis .elx-cell {
	  padding-left: 2px;
	  padding-right: 2px;
	}
	/deep/ .elx-table .elx-cell {
	  padding-left: 5px;
	  padding-right: 5px;
	}
	/deep/ .elx-table .elx-header--column:not(.col--ellipsis) {
	  padding: 0;
	  line-height: 34px;
	}
	/deep/ .elx-table .elx-footer--column:not(.col--ellipsis) {
	  padding: 0 2px;
	  line-height: 34px;
	}
	/deep/ .elx-table .elx-cell {
	  white-space: nowrap;
	  height: 28px;
	  line-height: 28px;
	}
	/deep/ .elx-table .elx-table--empty-content {
	  height: 100px;
	  line-height: 100px;
	}
	/deep/ .elx-table--footer .elx-footer--row .elx-cell {
	  padding-left: 7px;
	  padding-right: 7px;
	}
	/deep/ .el-button+.el-button{
	  margin-left: 10px;
	}
	/deep/ .el-button--text{
		font-size: 16px !important;
		color: #333333;
	}
	/deep/ .el-button--text:hover{
		font-size: 16px !important;
		color: #1E90FF;
	}
	/deep/ .el-tree-node__content{
		height: 32px;
		line-height: 32px;
	}
	
	
</style>

